import { render, staticRenderFns } from "./memberPoint.vue?vue&type=template&id=73af3e48&scoped=true&"
import script from "./memberPoint.vue?vue&type=script&lang=js&"
export * from "./memberPoint.vue?vue&type=script&lang=js&"
import style0 from "./memberPoint.vue?vue&type=style&index=0&id=73af3e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af3e48",
  null
  
)

export default component.exports